import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=ed2741a6&scoped=true&"
import script from "./DropdownButton.vue?vue&type=script&lang=js&"
export * from "./DropdownButton.vue?vue&type=script&lang=js&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=ed2741a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2741a6",
  null
  
)

export default component.exports